import "./ScheduleAVisit.module.css";
import Header from "@/reusable_sections/Header";
import BookYourTour from "./sections/BookYourTour";
import OurOfficeLocation from "./sections/OurOfficeLocation";
import Footer from "@/reusable_sections/Footer";
export default function ScheduleAVisitPage() {
  return <div>
      <Header />
      <BookYourTour />
      <OurOfficeLocation />
      <Footer />
    </div>;
}